import React from "react";
import "./ourServices.css";

export default function OurServices() {
  const mountData = (Structure) => {
    sessionStorage.setItem("Mount", Structure);
  };
  return (
    <section id="OurServices" className="ourServicesSection">
      <div className="servicesHead">
        <h1>Our Services</h1>
        <p>Why do you need to clean your solar panels?</p>
      </div>
      <div className="servicesList">
        <div className="servicesCard">
          <img src="./images/dust.webp" alt="roofType"></img>
          <div className="cardContent">
            <h5>Dust and Particulate Air Pollution</h5>
            <p>
              Dirt and grime and even grease and oil can settle on your panels
              over time. This can create hot spots on your panel which decreases
              the overall production of your solar panels and reduces the life
              of your system.
            </p>
          </div>
        </div>

        <div className="servicesCard" onClick={() => mountData("Trapoziadal")}>
          <img src="./images/pollen.webp" alt="roofType"></img>
          <div className="cardContent">
            <h5>Pollen and Tree Sap</h5>
            <p>
              Solar panel cleaning can help remove pollen and sap that cannot be
              removed by rain or a garden hose. Our Deionized water will remove
              these and is environmentally friendly.
            </p>
          </div>
        </div>

        <div className="servicesCard" onClick={() => mountData("Other")}>
          <img
            src="./images/birdDropping.webp"
            alt="roofType"
          ></img>
          <div className="cardContent">
            <h5>Bird Droppings</h5>
            <p>
              Critters like birds and squirrels can not only decrease your curb
              appeal but can cause serious damage to your solar system. We can
              clean and also provide protective barriers to prevent future
              nuisance animals (ask us for a free quote on bird barriers!).
            </p>
          </div>
        </div>
        <div className="servicesCard" onClick={() => mountData("Other")}>
          <img
            src="./images/panelCheckup.webp"
            alt="roofType"
          ></img>
          <div className="cardContent">
            <h5>Solar Panel Checkup</h5>
            <p>
              Not all solar cleaners are alike. Make sure you are using a
              licensed, bonded and insured solar company that can properly
              inspect your solar panel system to ensure it is performing at its
              optimum capacity.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
